import type { QuoteSubmission } from '@/util/types/serverTypeCollection/repairList';

export function isQwikFixQuoteSubmission(
  submission: Pick<QuoteSubmission, 'submissionType' | 'categoryId' | 'providerMetadata'>,
) {
  if (submission.submissionType === 'qwikfix') return true;
  return (
    submission.submissionType === 'partner' &&
    (submission.categoryId === 'qwikfix' || submission.providerMetadata?.provider === 'qwikFix')
  );
}
